var render = function render(){var _vm=this,_c=_vm._self._c;return _c('basic-container',{staticClass:"home-main h-100p pad-10 bg-fff"},[_c('div',{staticClass:"conditions-box"},[_vm._t("conditions")],2),_c('div',{staticClass:"list-box"},[_vm._t("content")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }